import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { cn } from "@/modules/lib/utils"
import { BoxStaffDetailedEntity } from "@modules/boxStaff/entities/boxStaffEntity"
import { word } from "@modules/core/utils/i18n"
import { PublicProfileDetails } from "@modules/profile/publicProfile/components/publicProfileDetails"
import { Dumbbell, Mail } from "lucide-react"
import { Text } from "@/components/ui/baseUi/text"

type BoxStaffTabProfileProps = {
  staffDetailed?: BoxStaffDetailedEntity | null
  className?: string
} & React.ComponentProps<"div">

export function BoxStaffTabProfile({ staffDetailed, className, ...props }: BoxStaffTabProfileProps) {
  // SKELETON
  if (!staffDetailed) {
    return (
      <div className={cn("flex w-full flex-col gap-12", className)} {...props}>
        {/* CONTACT */}
        <div className="mt-2 flex flex-col gap-4">
          <Text fontStyle="TM" className="text-textDefault-body">
            {word("box.member.table.profile.contact")}
          </Text>
          <div className="flex">
            <div className="flex flex-1 items-center gap-2">
              <Mail strokeWidth="1" />
              <Skeleton className="w-32 rounded-sm" />
            </div>
          </div>

          <div className="flex flex-row gap-2">
            <Dumbbell strokeWidth="1" />
            <div className="flex flex-col gap-1">
              <Text fontStyle="BS" className="text-textDefault-caption uppercase">
                {word("box.member.table.profile.startDate")}
              </Text>
              <Skeleton className="w-22 rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={cn("flex w-full flex-col gap-12", className)} {...props}>
      {/* CONTACT */}
      <div className="mt-2 flex flex-col gap-4">
        <Text fontStyle="TM" className="text-textDefault-body">
          {word("box.member.table.profile.contact")}
        </Text>
        <div className="flex">
          <div className="flex flex-1 gap-2">
            <Mail strokeWidth="1" />
            <Text fontStyle="TS" className="text-textDefault-body">
              {staffDetailed.email}
            </Text>
          </div>
        </div>
      </div>
      {staffDetailed.publicProfile && <PublicProfileDetails publicProfile={staffDetailed.publicProfile} />}
    </div>
  )
}
